import styled from 'styled-components';
import {useEffect, useMemo, useState} from "react";
import { useModal } from 'hooks/modalContext';

import * as Server from "assets/js/Server";

/* Chart */
import {Bar} from 'react-chartjs-2';
import 'chart.js/auto';
import CustomerHead from "../../components/customer/CustomerHead";

/* Icon */
import { IoIosCall } from "react-icons/io";
import { VscCircleFilled } from "react-icons/vsc";
import { IoDocumentText } from "react-icons/io5";
import * as Common from '../../assets/js/Common';

export default function TodayStatus() {

  const { openModal } = useModal();

  const [dailyList, setDailyList] = useState([]);
  const [dailyPestsList, setDailyPestsList] = useState([]);
  const [dailyCheckinList, setDailyCheckinList] = useState([]);
  const [dailyNfcTagList, setDailyNfcTagList] = useState([]);

  const getList = () => {
    Server.sendGet('customer/daily', {}, getListCallback).then();
  }

  const getListCallback = res => {
    setDailyList(res['resultObject']['dailyCheckList']);
    setDailyPestsList(res['resultObject']['pestsList']);
    setDailyCheckinList(res['resultObject']['checkinList'])
    setDailyNfcTagList(res['resultObject']['nfcTagList'])
  }

  useEffect(() => {
    getList();
  }, [])

  const options = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 10,
            font: {size: 12},
          },
          grid: {
            color: '#eee',
          },
        },
        x: {
          ticks: {
            font: {size: 12},
          },
          grid: {
            display: false,
          },
        },
      },
    }),
    []
  );

  const chartCntData = useMemo(() => {
    const mapping = {
      'Cockroaches' : '0',
      'Rodents' : '1',
      'Lizards ' : '2',
      'House Flies' : '3',
      'Other insects' : '4',
    };

    const labels = ['Cockroaches', 'Rodents', 'Lizards', 'House Flies', 'Other insects'];

    const pestCntMap = dailyPestsList.reduce((acc, cur) => {
      acc[cur.codeValue] = Number(cur.cnt);
      return acc;
    }, {});

    return labels.map(label => pestCntMap[mapping[label]] || 0);
  }, [dailyPestsList]);

  const data = {
    labels: ['Cockroaches', 'Rodents', 'Lizards', 'House Flies', 'Other insects'],
    datasets: [
      {
        label: 'Count',
        data: chartCntData,
        backgroundColor: 'rgba(255, 159, 64, 0.9)',
        borderRadius: 6,
        barPercentage: 0.6,
      },
    ],
  };

  const openImg = img => {
    if(img !== null && img !== '') {
      openModal({
        modalName: 'ImgDetail',
        modalData: {
          isRegi: true,
          data: {
            item: {
              img: img
            },
            callback: {},
          },
        }
      });
    }
  };

  return (
    <TodayWrap>
      <CustomerHead title="Today Pest Status" desc="Daily monitoring" />
      <main className="content">
        <div className="status-area card">
          <strong>On-site Personnel Status</strong>

          <div className="area-table">
            <table>
              <colgroup>
                <col width="20%"/>
                <col width="20%"/>
                <col width="60%"/>
              </colgroup>
              <thead>
              <tr>
                <th>Name</th>
                <th>Role</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody>
                {dailyCheckinList?.map((item, idx) => (
                  <>
                    <tr>
                      <td>{item.workerName}</td>
                      <td>{item.workerRole}</td>
                      <td>
                        <div className="status-btn">
                          <button className='status-btn active'>
                            <VscCircleFilled />
                            <span>Active</span>
                          </button>

                          <button
                            className='call-btn'
                            onClick={() => {
                              window.location.href = `tel:${item.workerPhone}`;
                            }}
                          >
                            <IoIosCall />
                            <span>Call</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pest-area card">
          <strong>Customer Main Pest Control Area</strong>

          <div className="area-table">
            <table>
              <colgroup>
                <col width="50%"/>
                <col width="20%"/>
                <col width="30%"/>
              </colgroup>
              <thead>
              <tr>
                <th>Area</th>
                <th>Status</th>
                <th>Time</th>
              </tr>
              </thead>
              <tbody>
              {dailyList?.map((row, index) => (
                  <tr key={index}>
                    <td>{row.patrolArea}</td>
                    <td>
                      <span className="status">{row.tagTime ? "Completed" : "Before"}</span>
                    </td>
                    <td>{row.tagTime}</td>
                  </tr>
              ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pest-chart card">
          <strong>Current Status of Pest Occurrence</strong>
          <div className="area-chart">
            <Bar data={data} options={options}/>
          </div>
        </div>
        <div className="nfc-area card">
          <strong>On-site Personnel Status</strong>
          <div className="area-table">
            <table>
              <colgroup>
                <col width="25%"/>
                <col width="25%"/>
                <col width="25%"/>
                <col width="25%"/>
              </colgroup>
              <thead>
              <tr>
                <th>Area</th>
                <th>Last Tagged Time</th>
                <th>Uploaded By</th>
                <th>Comment</th>
                <th>Image</th>
              </tr>
              </thead>
              <tbody>
                {dailyNfcTagList?.map((item, idx) => (
                  <>
                    <tr
                      onClick={() => openImg(item.pestImg)}
                    >
                      <td>{item.patrolArea}</td>
                      <td>{item.tagTime}</td>
                      <td>{item.workerName}</td>
                      <td>{item.pestCheckResult}</td>
                      <td>{item.pestImg ? 'O' : 'X'}</td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </TodayWrap>
  )
}

const TodayWrap = styled.div`
  position: relative;
  background: #F9FAFB;

  .content {
    position:relative;
    padding: 20px;
    //height:calc(100vh - 132px);
    overflow-y:auto;
    
    .card {
      background:#fff;
      border-radius:12px;
      padding:20px;
      box-shadow:0 1px 3px rgba(0, 0, 0, 0.1);
      
      strong {
        display:block;
        font-size:18px;
        font-weight:700;
        color:#111827;
      }
    }
    
    .card + .card {
      margin-top:16px;
    }
    
    .search-menu {
      display:flex;
      gap:0 15px;

      .input-box {
        flex:1;
        
        input {
          width:100%;
          height:40px;
          padding:10px 20px;
          border-radius:8px;
          border:1px solid #ddd;
          outline:none;
          font-weight:400;
          font-size:14px;
          color:#111;
        }
        
        label {
          display:none;
        }
      }

      .search-btn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        background: #0072B9;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
      }
    }

    .area-table {
      position:relative;
      margin-top:20px;
      max-height:250px;
      overflow-y:auto;

      table {
        position:relative;
        width:100%;
        border-collapse: collapse;
        border-bottom:1px solid #ddd;

        thead {
          position:sticky;
          top:0;
          left:0;
          
          tr {
            background:#f3f4f6;

            th {
              padding:12px;
              font-size:14px;
              font-weight:600;
              color:#4b5563;
            }
          }
        }
        
        tbody tr {
          border-bottom:1px solid #f3f4f6;

          td {
            padding:12px;
            font-size:12px;
            color:#374151;
            text-align:center;
            
            .status {
              display: inline-block;
              padding:4px 8px;
              border-radius:9999px;
              font-size:12px;
              font-weight:500;
            }
            
            .status-btn {
              display:flex;
              align-items: center;
              justify-content: center;
              gap:0 5px;
              
              button {
                padding:0 10px;
                display:inline-flex;
                justify-content: center;
                align-items:center;
                gap:0 5px;
                height:25px;
                border-radius:6px;
                
                span {
                  font-weight:400;
                  font-size:10px;
                  line-height:25px;
                }
              }
              
              .status-btn {
                color:#111;
                background:#e7e7e7;
                
                &.active {
                  color:#fff;
                  background:#50b047;
                }
              }
              
              .call-btn {
                color:#fff;
                background:#0072B9;
              }
              
              .log-btn {
                color:#fff;
                background:#4289c8;
              }
            }
          }
        }

        tr:nth-child(even) td {
          background:#f9f9f9;
        }
      }
      
      .tbody-scroll {
        display: block;
        width:100%;
        max-height: 250px;      /* 스크롤 높이 */
        overflow-y: auto;
      }
    
      .tbody-scroll tbody {
        display: block;
      }
    
      .tbody-scroll tr {
        display: table;
        width: 100%;
        table-layout: fixed;
      }
    }

    .area-chart {
      margin-top:20px;
      min-height:240px;
    } 
  }
`

